const Theme = {
  body_background_color: '#ffd232',

  card_header_title_centered: true,
  token_hidden: true,

  button_color: '#3F6CB3',
  button_font: `'Nunito', sans-serif`,
  button_radius: 25,
  button_padding: 0,
  button_width: 250,
  button_centered: true,

  text_font: `'Nunito', sans-serif`,
  text_color: '#12263F',
  text_centered: true,

  title_centered: true,
}

export default Theme
